import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';
import indaba from "./images/indaba.jpeg";
import indaba2 from "./images/indaba2.jpeg";
import indaba3 from "./images/moi1.jpg";
import indaba4 from "./images/moi2.jpg";
import indaba5 from "./images/moi3.jpg";
import indaba6 from "./images/moi4.jpg";
import indaba7 from "./images/moi5.jpg";


const SinistrIA = () => {
    const mediaItems = [
        {
            type: 'youtube',
            src: 'https://www.youtube.com/embed/70kfiX9f_sU',
        },
        {
            type: 'video',
            src: require('./images/sinistrIA_reel.mp4'),
        },
        {
            type: 'image',
            src: indaba,
        },
        {
            type: 'image',
            src: indaba2,
        },
        {
            type: 'image',
            src: indaba3,
        },
        {
            type: 'image',
            src: indaba4,
        },
        {
            type: 'image',
            src: indaba5,
        },
        {
            type: 'image',
            src: indaba6,
        },
        {
            type: 'image',
            src: indaba7,
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">SinistrIA</h2>
        <span className="section__subtitle">
            My startup!
            <a href="https://www.linkedin.com/company/sinistria" target="_blank" rel="noopener noreferrer" style={{marginLeft: '10px', color: '#0077b5', fontSize: '1.2em'}}>
                <i className="uil uil-linkedin"></i>
            </a>
        </span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>SinistrIA is my startup focused on revolutionizing insurance claims management through advanced AI technologies. We've developed a comprehensive B2B SaaS platform that automates and enhances the entire claims processing workflow.</p>
                <br />
                <p className='redRadio__text'><strong>Key Features I Developed:</strong></p>
                <br />
                <p className='redRadio__text'>📄 <strong>Our Own finetuned OCR Claims Processing</strong> - Automated document extraction and processing</p>
                <br />
                <p className='redRadio__text'>🔍 <strong>Fraud Detection</strong> - AI-powered fraud identification and prevention</p>
                <br />
                <p className='redRadio__text'>💻 <strong>Damage Assessment</strong> - Computer vision models for automated damage evaluation</p>
                <br />
                <p className='redRadio__text'>🌐 <strong>Web Search MCP</strong> - Model Context Protocol for enhanced web searches</p>
                <br />
                <p className='redRadio__text'>🎮 <strong>3D Accident Simulation</strong> - Interactive accident reconstruction and visualization</p>
                <br />
                <p className='redRadio__text'>📊 <strong>Case Classification</strong> - Intelligent categorization of accident and insurance cases</p>
                <br />
                <p className='redRadio__text'>This platform transforms traditional insurance operations by providing insurers with cutting-edge AI tools for faster, more accurate, and cost-effective claims processing.</p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">YOLO11</h3>
                <span className="skills__level">Technology</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">OpenCV</h3>
                <span className="skills__level">Technology</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">NextJS</h3>
                <span className="skills__level">Frontend</span>
            </div>
            </div>
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Finetuning</h3>
                <span className="skills__level">Techniques</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">ThreeJS</h3>
                <span className="skills__level">Frontend</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">MCP</h3>
                <span className="skills__level">Backend</span>
              </div>
            </div>
          
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">React</h3>
              <span className="skills__level">Mobile</span>
            </div>
          </div>
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default SinistrIA;